import { FC } from "react";
import { Link } from "react-router-dom";

export const NoMatch: FC = () => (
  <div>
    <h2>Whoops looks like you're lost.</h2>
    <Link to="/">Head back home.</Link>
  </div>
);
